// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7f-4";
export var collapsed = "_7f-1";
export var headerBar = "_7f-0";
export var leftHeaderContent = "_7f-3";
export var subjectContainer = "_7f-2";